export default "__VITE_ASSET__Dmy5dyga__"